import { StatisticsOrder } from '@dreryk/egabinet-statistics-frontend-api';

import {
   appendTestableComponentAttributes,
   EmptyStatePlaceholder,
   Heading,
   StyledFlex,
   Table,
} from '@dreryk/react-components';

import { statisticsTranslationKeys } from '../../translations';

import { useStatisticsOrderColumns, useStatisticsOrderDataConfiguration } from './StatisticsOrderTable.hooks';

export const StatisticsOrderTable = (): JSX.Element => (
   <StyledFlex direction={'column'}>
      <Heading
         testId={'statisticsOrderHeader'}
         type={'h2'}
         content={statisticsTranslationKeys.orderTable.header}
         {...appendTestableComponentAttributes('Header', 'statisticsOrderHeader')}
      />
      <Table<StatisticsOrder>
         testId={'statisticsOrderTable'}
         columns={useStatisticsOrderColumns()}
         dataConfiguration={useStatisticsOrderDataConfiguration()}
         keyExtractor={'id'}
         pageSize={10}
         placeholder={
            <EmptyStatePlaceholder
               heading={statisticsTranslationKeys.orderTable.noResultsLabel}
               subheading={statisticsTranslationKeys.orderTable.noResultsSubText}
               testId={'noResults'}
            />
         }
      />
   </StyledFlex>
);
